import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { MainContent, PageHeading } from '../../components/Shell/Content';
import LoadingSkeleton from '../../components/Shell/LoadingSkeleton';
import Tabs from '../../components/Tabs';
import DataTable from '../../components/DataTable';
import Button from '../../components/Button';

import useAsync from '../../hooks/useAsync';
import { getConsumable } from '../../api/consumables';

const Consumable = () => {
	const navigate = useNavigate();
	const { id } = useParams();
	const [activeTab, setActiveTab] = useState(null);
	const { value: consumable, status } = useAsync(getConsumable, {
		defaultPayload: { id },
	});
	if (status === 'pending') {
		return <LoadingSkeleton />;
	}

	return (
		<MainContent maxWidth="max-w-4xl">
			<PageHeading
				onBack={() => navigate(`/consumables/all`)}
			>{`Consumable: ${consumable?.name}`}</PageHeading>

			<Tabs
				className="-mt-4"
				tabs={[
					{
						name: 'General',
						key: 'general',
						onClick: (key) => setActiveTab(key),
					},
					{
						name: 'Attributes',
						key: 'attributes',
						onClick: (key) => setActiveTab(key),
					},
					{
						name: 'Settings',
						key: 'settings',
						onClick: (key) => setActiveTab(key),
					},
				]}
				activeTab={activeTab}
			>
				{(tab) => {
					if (tab === 'general') {
						return (
							<>
								<div className="grid grid-cols-1 sm:grid-cols-2">
									<div className="mt-3 border-gray-100">
										<dl className="divide-y divide-gray-100">
											<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
												<dt className="text-xs font-medium leading-6 text-gray-900">
													Name
												</dt>
												<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
													{consumable?.name}
												</dd>
											</div>
											<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
												<dt className="text-xs font-medium leading-6 text-gray-900">
													Vendor
												</dt>
												<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
													{consumable?.vendor?.companyName || 'No vendor set'}
												</dd>
											</div>
											<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
												<dt className="text-xs font-medium leading-6 text-gray-900">
													Category{' '}
												</dt>
												<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
													{consumable?.category?.name || 'No category set'}
												</dd>
											</div>

											<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
												<dt className="text-xs font-medium leading-6 text-gray-900">
													Pack Size
												</dt>
												<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
													{consumable?.packSize}
												</dd>
											</div>

											<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
												<dt className="text-xs font-medium leading-6 text-gray-900">
													Packs Per Case
												</dt>
												<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
													{consumable?.packsPerCase}
												</dd>
											</div>

											{consumable?.attributes?.map((attr) => (
												<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
													<dt className="text-xs font-medium leading-6 text-gray-900">
														{attr?.attribute_field?.label}
													</dt>
													<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
														{attr?.attribute_field?.type === 'vendor'
															? attr?.vendor?.companyName
															: attr?.value}
													</dd>
												</div>
											))}
										</dl>
									</div>
									<div>
										{consumable?.image ? (
											<img
												class="aspect-[3/2] w-full rounded-2xl object-cover"
												src={consumable?.image}
												alt=""
											/>
										) : (
											<>
												{/*<div className="w-full border rounded h-40">
												<BeakerIcon className="w-4 h-4 text-gray-400" />
										</div>*/}
											</>
										)}
									</div>
								</div>
								<div className="mt-6">
									<DataTable title="Inventory" />
								</div>
							</>
						);
					}

					if (tab === 'attributes') {
						return (
							<div>
								<div className="mt-3 border-gray-100">
									<dl className="divide-y divide-gray-100">
										{consumable?.attributes?.length ? (
											consumable?.attributes?.map((attr) => (
												<div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
													<dt className="text-xs font-medium leading-6 text-gray-900">
														{attr?.attribute_field?.label}
													</dt>
													<dd className="mt-1 text-xs leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
														{attr?.attribute_field?.type === 'vendor'
															? attr?.vendor?.companyName
															: attr?.value}
													</dd>
												</div>
											))
										) : (
											<div>No attributes added</div>
										)}
									</dl>
								</div>
							</div>
						);
					}

					if (tab === 'settings') {
						return (
							<div className="space-y-12 mt-8">
								<div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
									<div>
										<h2 className="text-sm font-semibold leading-7 text-gray-900">
											Delete Consumable
										</h2>
										<p className="mt-1 text-xs leading-6 text-gray-600">
											Once you delete a consumable, there is no going back.
											Please be certain
										</p>
									</div>
									<div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8">
										<div>
											<Button
												type="danger"
												onClick={() =>
													openDeleteModal({
														title:
															'Are you sure you want to delete this storage point?',
														form: (form, onChange) => (
															<div className="py-4">
																<TemplateBoolean
																	name="Reset inventory counts (if applicable)?"
																	onChange={(index, reset) => {
																		if (typeof onChange === 'function') {
																			onChange({
																				...form,
																				resetInventory: reset,
																			});
																		}
																	}}
																	value={form?.resetInventory}
																/>
																<p className="text-xxs mt-2">
																	By resetting the inventory count, you remove
																	all consumables attached to this storage point
																</p>
															</div>
														),
														defaultForm: { resetInventory: true },
														confirmText: 'Delete Storage Point',
														onConfirm: (form) =>
															onDeleteStoragePoint(
																{
																	id,
																	resetInventory: form?.resetInventory,
																},
																() => {
																	closeDeleteModal();
																	navigate('/consumables/storage-points');
																}
															),
													})
												}
											>
												Delete Consumable
											</Button>
										</div>
									</div>
								</div>
							</div>
						);
					}
				}}
			</Tabs>
		</MainContent>
	);
};

export default Consumable;
